export default __webpack_public_path__ + "assets/img/img-icon-requirement-success.664f6ee2b08af7d301f14b9e93e0765e.svg";